module.exports = { id: "low-entry", url: "/build/app/img/symbols.svg#low-entry", viewBox: "", toString: function() { return this.url; } };